export const iconNameToEmoji: Record<string, string> = {
  'utensils': '🍴',
  'bus': '🚌',
  'shopping-bag': '🛍️',
  'briefcase': '💼',
  'circle': '📍',
  'food': '🍔',
  'transport': '🚗',
  'shopping': '🛒',
  'services': '⚙️',
  'others': '📍',
}



